<template>
  <div>
    <h1>Daily QR Registration</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'MAIN DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- <flexibleFilter
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter> -->
    <!-- FILTER ENDS -->

    <!-- Registration By Date Start -->
    <daily-registered
      class="mt-5"
      :filterUrl="filterUrl"
    ></daily-registered>
    <!-- Registration By Date End -->

    <div class="mt-5" style="background-color: black; color:white; padding:0.5%;">
      <h3 style="margin:0;">VEHICLE MAPPING SUMMARY</h3>
    </div>
    <!-- Registered By Main Dealer Start -->
    <div class="innerBox mt-2">
      <h5 class="mb-2">Registered By Main Dealer</h5>
      <registered-by-main-dealer
        :filterUrl="filterUrl"
      ></registered-by-main-dealer>
    </div>
    <!-- Registered By Main Dealer End -->

    <!-- Registered By Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Registered By Category</h5>
      <registered-by-category
        :filterUrl="filterUrl"
      ></registered-by-category>
    </div>
    <!-- Registered By Category End -->

    <!-- Category Registration Start -->
    <div class="row">
      <div class="col-md-6">
        <!-- Sport Start -->
        <div class="innerBox mt-5">
          <h5 class="mb-2">Sport Registration</h5>
          <category-registration
            :filterUrl="filterUrl"
            :category="'SPORT'"
          ></category-registration>
        </div>
        <!-- Sport End -->
      </div>
      <div class="col-md-6">
        <!-- Cub Start -->
        <div class="innerBox mt-5">
          <h5 class="mb-2">Cub Registration</h5>
          <category-registration
            :filterUrl="filterUrl"
            :category="'CUB'"
          ></category-registration>
        </div>
        <!-- Cub End -->
      </div>
      <div class="col-md-6">
        <!-- AT Start -->
        <div class="innerBox mt-5">
          <h5 class="mb-2">AT Registration</h5>
          <category-registration
            :filterUrl="filterUrl"
            :category="'AT'"
          ></category-registration>
        </div>
        <!-- AT End -->
      </div>
    </div>
    <!-- Category Registration End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import dailyRegistered from './children/dailyRegistered'
  import registeredByMainDealer from './children/registeredByMainDealer'
  import registeredByCategory from './children/registeredByCategory'
  import categoryRegistration from './children/categoryRegistration'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      dailyRegistered,
      registeredByMainDealer,
      registeredByCategory,
      categoryRegistration,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>